import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useApiTranslations} from '../../../../context/ApiTranslationsContext';
import {SupportPlanController} from '../../../../api/support/support-plan.controller';
import {SupportSlotsController} from '../../../../api/support/support-slots.controller';
import {useInitialLoad} from '../../../../hook/use-initial-load';
import {SupportSlotAssignmentTypeEnum} from '../../../../model/support/slot/support-slot-assignment-type.enum';
import {SupportSlotCustomerAssignmentModel} from '../../../../model/support/slot/support-slot-customer-assignment.model';
import {SupportCustomerModel} from '../../../../model/support/support-customer.model';
import {SupportSlotDefinitionPageHooks} from './support-slot-definition-page-hooks';

export type SupportSlotDefinitionPreviewCustomersTabState = {
  selectedType: SupportSlotAssignmentTypeEnum | null
  setSelectedType: (type: SupportSlotAssignmentTypeEnum) => void
  selectedCustomer: string | null
  setSelectedCustomer: (planId: string) => void
  onCreateAssignmentPressed: () => Promise<void>
  onAssignmentDeletePressed: (assignmentId: string, version: number) => Promise<void>
  slotAssignments: SupportSlotCustomerAssignmentModel[]
  customers: SupportCustomerModel[]
  translate: (key: string) => string
}

export const useSupportSlotDefinitionPreviewCustomersTabState = (slotDefinitionId: string): SupportSlotDefinitionPreviewCustomersTabState => {
  const {t} = useTranslation()
  const {translate: apiTranslate} = useApiTranslations()
  const customers = useInitialLoad(async () => SupportPlanController.fetchSupportCustomers())
  const [selectedType, setSelectedType] = useState<SupportSlotAssignmentTypeEnum | null>(null)
  const [selectedCustomer, setSelectedCustomer] = useState<string | null>(null)

  const [slotDefinitionAssignments, setSlotDefinitionAssignments] = SupportSlotDefinitionPageHooks.useSupportSlotDefinitionAssignments(slotDefinitionId)

  const refreshSlotDefinitionAssignments = async () => {
    setSlotDefinitionAssignments(await SupportSlotDefinitionPageHooks.fetchSupportSlotDefinitionAssignments(slotDefinitionId))
  }
  return {
    selectedType: selectedType,
    selectedCustomer: selectedCustomer,
    customers: customers ?? [],
    slotAssignments: slotDefinitionAssignments,
    onCreateAssignmentPressed: async () => {
      if(selectedCustomer && selectedType) {
        await SupportSlotsController.createSupportSlotAssignment({
          planId: selectedCustomer,
          slotDefinitionId: slotDefinitionId,
          assignmentType: selectedType
        })
        await refreshSlotDefinitionAssignments()
      }
      setSelectedCustomer(null)
      setSelectedType(null)
    },
    onAssignmentDeletePressed: async (assignmentId, version) => {
      await SupportSlotsController.deleteSupportSlotDefinitionAssignment(assignmentId, version)
      await refreshSlotDefinitionAssignments()
    },
    setSelectedType: setSelectedType,
    setSelectedCustomer: setSelectedCustomer,
    translate: (key) => apiTranslate(key) || t(key)
  }
}